import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { GET_PRODUCT_GLOBAL_MINIMUM_AND_TARGET_STOCK } from "../../../data/definitions/product-definition";
import { COPY_PRODUCT_TO_STORAGE_PLACE_LINK, DELETE_PRODUCT_TO_STORAGE_PLACE_LINK, GET_PRODUCT_TO_STORAGE_PLACE_LINK, GET_PRODUCT_TO_STORAGE_PLACE_LINKS, SAVE_PRODUCT_TO_STORAGE_PLACE_LINK, SAVE_PRODUCT_TO_STORAGE_PLACE_LINKS } from "../../../data/definitions/product-to-storage-place-link.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { CopyProductToStoragePlaceLinkMutation, CopyProductToStoragePlaceLinkMutationVariables, DeleteProductToStoragePlaceLinkMutation, DeleteProductToStoragePlaceLinkMutationVariables, DeletionResponse, GetProductToStoragePlaceLinkQuery, GetProductToStoragePlaceLinkQueryVariables, GetProductToStoragePlaceLinksQuery, GetProductToStoragePlaceLinksQueryVariables, ProductToStoragePlaceLink, ProductToStoragePlaceLinkInput, SaveProductToStoragePlaceLinkMutation, SaveProductToStoragePlaceLinkMutationVariables, SaveProductToStoragePlaceLinksMutation, SaveProductToStoragePlaceLinksMutationVariables, SearchInput } from "../../../generated/generated-types";


@Injectable({
  providedIn: 'root'
})
export class ProductToStoragePlaceLinkService extends BaseListService<ProductToStoragePlaceLink> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, options?: ICRUDOptions) {

    let fragment = GET_PRODUCT_TO_STORAGE_PLACE_LINKS;

    if (options?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, options.currentColumnConfig.baseView, options.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetProductToStoragePlaceLinksQuery, GetProductToStoragePlaceLinksQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetProductToStoragePlaceLinkQuery, GetProductToStoragePlaceLinkQueryVariables>(
      GET_PRODUCT_TO_STORAGE_PLACE_LINK, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getProductToStoragePlaceLink);
  }

  async getItemData(id: string): Promise<ProductToStoragePlaceLink> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getProductToStoragePlaceLink as ProductToStoragePlaceLink;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {

    // let res = await this.baseDataService.mutate<DeleteProductToStoragePlaceLink.Mutation, DeleteProductToStoragePlaceLink.Variables>(
    //   DELETE_PRODUCT_TO_STORAGE_PLACE_LINK, {
    //   id: id
    // }).toPromise();
    return await lastValueFrom(this.baseDataService.mutate<DeleteProductToStoragePlaceLinkMutation, DeleteProductToStoragePlaceLinkMutationVariables>(
      DELETE_PRODUCT_TO_STORAGE_PLACE_LINK, {
      id: id
    })
    ).then(x => { return x.deleteProductToStoragePlaceLink });
    // return res.deleteProductToStoragePlaceLink
  }

  async saveItem(productGroup: ProductToStoragePlaceLink | ProductToStoragePlaceLinkInput) {

    let validated = await this.systemService.validateObject<ProductToStoragePlaceLinkInput>(productGroup, "ProductToStoragePlaceLinkInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveProductToStoragePlaceLinkMutation, SaveProductToStoragePlaceLinkMutationVariables>(
      SAVE_PRODUCT_TO_STORAGE_PLACE_LINK, {
      input: validated
    }, null,
      [{
        query: GET_PRODUCT_GLOBAL_MINIMUM_AND_TARGET_STOCK,
        variables: { id: validated.productId }
      }]));

    return saved.saveProductToStoragePlaceLink as ProductToStoragePlaceLink;
  }

  async saveItems(input: ProductToStoragePlaceLinkInput[]): Promise<ProductToStoragePlaceLink[]> {
    const validatedInput: ProductToStoragePlaceLinkInput[] = [];
    for (const link of input) {
      const validated = await this.systemService.validateObject<ProductToStoragePlaceLinkInput>(link, "ProductToStoragePlaceLinkInput");
      validatedInput.push(validated);
    }

    const productIds = [...new Set(validatedInput.map(link => link.productId).filter(Boolean))];
    const saved = await lastValueFrom(this.baseDataService.mutate<SaveProductToStoragePlaceLinksMutation, SaveProductToStoragePlaceLinksMutationVariables>(
      SAVE_PRODUCT_TO_STORAGE_PLACE_LINKS, {
      input: validatedInput
    }, null,
      productIds.map(id => ({
        query: GET_PRODUCT_GLOBAL_MINIMUM_AND_TARGET_STOCK,
        variables: { id }
      }))));

    return saved.saveProductToStoragePlaceLinks as ProductToStoragePlaceLink[];
  }

  async copyItem(id: string) {

    let saved = await lastValueFrom(this.baseDataService.mutate<CopyProductToStoragePlaceLinkMutation, CopyProductToStoragePlaceLinkMutationVariables>(
      COPY_PRODUCT_TO_STORAGE_PLACE_LINK, {
      id: id
    }));

    return saved.copyProductToStoragePlaceLink as ProductToStoragePlaceLink;
  }

  //#endregion

}
